var map = {
	"./Level0.svg": 1656,
	"./Level1.svg": 1657,
	"./Level10.svg": 1658,
	"./Level11.svg": 1659,
	"./Level12.svg": 1660,
	"./Level13.svg": 1661,
	"./Level14.svg": 1662,
	"./Level15.svg": 1663,
	"./Level16.svg": 1664,
	"./Level17.svg": 1665,
	"./Level18.svg": 1666,
	"./Level19.svg": 1667,
	"./Level2.svg": 1668,
	"./Level20.svg": 1669,
	"./Level21.svg": 1670,
	"./Level22.svg": 1671,
	"./Level23.svg": 1672,
	"./Level24.svg": 1673,
	"./Level25.svg": 1674,
	"./Level26.svg": 1675,
	"./Level27.svg": 1676,
	"./Level28.svg": 1677,
	"./Level29.svg": 1678,
	"./Level3.svg": 1679,
	"./Level30.svg": 1680,
	"./Level31.svg": 1681,
	"./Level32.svg": 1682,
	"./Level33.svg": 1683,
	"./Level34.svg": 1684,
	"./Level35.svg": 1685,
	"./Level36.svg": 1686,
	"./Level37.svg": 1687,
	"./Level38.svg": 1688,
	"./Level39.svg": 1689,
	"./Level4.svg": 1690,
	"./Level40.svg": 1691,
	"./Level5.svg": 1692,
	"./Level6.svg": 1693,
	"./Level7.svg": 1694,
	"./Level8.svg": 1695,
	"./Level9.svg": 1696
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1655;